var r=(r=[])=>{const a=new Set(Array.isArray(r)?r:[r]);return r=>!a.has(r)};export{r as excludeForwardProps};
//# sourceMappingURL=excludeForwardProps.js.map